module.exports = __webpack_public_path__ + "static/media/RealTimeCommunication_web_001.00728591.png";